import { FC } from 'react';

import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import { useModalContext } from '../../../hooks/contexts/modal.context';
import * as Styles from './summary.styles';

export type RestrictedAssignProps = {
  navigateToNextRoute: () => void;
};

const RestrictedAssign: FC<RestrictedAssignProps> = ({ navigateToNextRoute }) => {
  const { translate } = useI18nContext();
  const { toggleModal } = useModalContext();

  const handleConfirm = () => {
    navigateToNextRoute();
    toggleModal({ open : false });
  };

  return (
    <Styles.RestrictedAssignContent>
      <p>
        <strong>{translate(['INFORMATION', 'ASSIGNMENT_RESTRICTED_DESCRIPTION_BOLD'])}</strong>
        {translate(['INFORMATION', 'ASSIGNMENT_RESTRICTED_DESCRIPTION'])}
      </p>
      <Styles.ButtonGroup>
        <button onClick={() => toggleModal({ open : false })}>
          {translate(['INFORMATION', 'ASSIGNMENT_RESTRICTED_CANCEL_BTN'])}
        </button>
        <button
          onClick={handleConfirm}
        >
          {translate(['STEPS', 'TXT15'])}
        </button>
      </Styles.ButtonGroup>
    </Styles.RestrictedAssignContent>
  );
};

export default RestrictedAssign;
